/* Shared catalogue UI. Native GETs retain Shopify semantics, analytics and browser history. */
(() => {
  function initialize(root) {
    if (root.dataset.ftReady) return;
    root.dataset.ftReady = 'true';
    root.classList.add('ft-apparel--enhanced');
    if (matchMedia('(max-width:1023px)').matches) root.querySelector('[data-ft-categories]')?.removeAttribute('open');
    const current = new URL(window.location.href);
    const isSearch = root.dataset.search === 'true';
    const view = current.searchParams.get('view');
    const sidebar = root.querySelector('.ft-apparel__sidebar');
    if (!sidebar) return;
    // Keep alternate-template previews and apparel search scoped across native requests.
    root.querySelectorAll('form:not([data-ft-search])').forEach(form => {
      if (view && !form.querySelector('[name="view"]')) {
        const field = document.createElement('input');
        field.type = 'hidden'; field.name = 'view'; field.value = view; form.append(field);
      }
      if (isSearch && root.dataset.catalogue !== 'apparel' && current.searchParams.has('apparel_query')) {
        const field = document.createElement('input');
        field.type = 'hidden'; field.name = 'apparel_query'; field.value = current.searchParams.get('apparel_query'); form.append(field);
      }
    });
    function preserveView(link) {
      if (!view) return;
      const url = new URL(link.getAttribute('href'), window.location.origin);
      if (url.origin === current.origin && url.pathname === current.pathname) {
        url.searchParams.set('view', view);
        if (isSearch) url.searchParams.set('type', 'product');
        if (isSearch && root.dataset.catalogue !== 'apparel' && !link.hasAttribute('data-ft-clear') && current.searchParams.has('apparel_query')) {
          url.searchParams.set('apparel_query', current.searchParams.get('apparel_query'));
        }
        link.href = url.pathname + url.search;
      }
    }
    root.querySelectorAll('[data-ft-filter-link],[data-ft-clear],[data-ft-pagination],.pagination a').forEach(preserveView);
    root.querySelectorAll('[data-ft-more]').forEach(button => {
      button.hidden = false;
      button.addEventListener('click', () => {
        const group = button.closest('[data-ft-group]');
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        group.toggleAttribute('data-ft-expanded', expanded);
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? 'Show fewer' : 'Show more';
      });
    });
    const search = root.querySelector('[data-ft-search]');
    const queryInput = search.querySelector('[name="apparel_query"]');
    const submittedQuery = current.searchParams.get('apparel_query');
    if (isSearch && submittedQuery !== null) queryInput.value = submittedQuery;
    search.querySelector('[data-ft-search-button]').hidden = false;
    search.addEventListener('submit', () => {
      // Escape query syntax while retaining native prefix/SKU matching (quoting every word disables it).
      const words = queryInput.value.trim().split(/\s+/).filter(Boolean)
        .map(word => /^(AND|OR|NOT)$/i.test(word) ? '"' + word + '"'
          : word.replace(/[\\:()"']/g, '\\$&').replace(/^-/, '\\-'));
      // Explicit native fields avoid Shopify broadening a bare keyword when mixed with tag scope.
      // Keep the established apparel query unchanged; extended catalogues use the same native engine.
      let query = words.join(' ');
      if (words.length && root.dataset.catalogue && root.dataset.catalogue !== 'apparel') {
        const terms = words.map(word => '(' + ['title', 'variants.sku', 'body', 'product_type', 'tag'].map(field => field + ':' + word).join(' OR ') + ')').join(' AND ');
        const fullSku = queryInput.value.trim().replace(/[\\"]/g, '\\$&');
        query = 'variants.sku:"' + fullSku + '" OR (' + terms + ')';
      }
      search.querySelector('[name="q"]').value = (root.dataset.searchScope || 'tag:source_apparel') + (query ? ' AND (' + query + ')' : '');
    });
    root.querySelector('[data-ft-sort]')?.addEventListener('change', event => event.target.form.requestSubmit());
    root.querySelectorAll('[data-ft-views]').forEach(controls => { controls.hidden = false; });
    root.querySelectorAll('[data-ft-view]').forEach(button => button.addEventListener('click', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('pgview', button.dataset.ftView);
      url.searchParams.delete('page');
      window.location.assign(url.href);
    }));
    root.querySelector('[data-ft-filters]')?.addEventListener('submit', event => {
      event.target.querySelectorAll('input[type="number"]').forEach(input => { input.disabled = !input.value; });
    });
    // One copy of the filters moves into a native dialog: focus trapping, inert background and Escape.
    const open = root.querySelector('[data-ft-open]');
    const close = root.querySelector('[data-ft-close]');
    const dialog = document.createElement('dialog');
    if (typeof dialog.showModal !== 'function') {
      root.classList.remove('ft-apparel--enhanced');
      return; // Older browsers retain the in-flow filters.
    }
    dialog.className = 'ft-apparel__dialog';
    dialog.setAttribute('aria-labelledby', sidebar.querySelector('h2').id);
    root.append(dialog);
    const marker = document.createComment('apparel-sidebar');
    sidebar.before(marker);
    open.hidden = false;
    let previousOverflow = '';
    open.addEventListener('click', () => {
      dialog.append(sidebar);
      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      open.setAttribute('aria-expanded', 'true');
      dialog.showModal();
      close.focus();
    });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog && event.clientX < dialog.getBoundingClientRect().left) dialog.close(); });
    dialog.addEventListener('close', () => {
      marker.after(sidebar);
      document.documentElement.style.overflow = previousOverflow;
      open.setAttribute('aria-expanded', 'false');
      // Cancel unapplied choices, keeping the products/chips consistent when the drawer closes.
      sidebar.querySelector('[data-ft-filters]')?.reset();
      open.focus();
    });
    matchMedia('(min-width:1024px)').addEventListener('change', event => { if (event.matches && dialog.open) dialog.close(); });
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      root.querySelectorAll('input[type="number"]').forEach(input => { input.disabled = false; });
      if (dialog.open) dialog.close();
    });
  }
  document.querySelectorAll('[data-ft-apparel]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ft-apparel]').forEach(initialize));
})();
